export function buildUrlFromParams(url, params) {
  let queryString = buildQueryStringFromParams(params);

  if (queryString) {
    url = url + '?' + queryString;
  }

  return url;
}

export function buildQueryStringFromParams(params) {
  let queryString = Object.keys(params)
    .filter(key => params[key])
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    .join('&');

  return queryString;
}

export function buildUrlFromFields(url, fields) {
  let queryString = buildQueryStringFromFields(fields);

  if (queryString) {
    url = url + '?' + queryString;
  }

  return url;
}

export function buildQueryStringFromFields(fields) {
  let queryString = fields
    .filter(field => field.value)
    .map(field => encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value))
    .join('&');

  return queryString;
}